import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { useLanguage } from '../i18n/LanguageContext';
interface PrivacyPolicyPageProps {
  onNavigate: (page: string) => void;
}
export function PrivacyPolicyPage({
  onNavigate
}: PrivacyPolicyPageProps) {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-26787">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-26788">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26789">
          <Breadcrumbs items={[{
          label: t('legal.backToHome'),
          onClick: () => onNavigate('home')
        }, {
          label: t('legal.privacy.title')
        }]} className="mb-8" data-id="element-26790" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-26791">
            {t('legal.privacy.title')}
          </h1>
          <p className="text-slate-500" data-id="element-26792">{t('legal.lastUpdated')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-26793">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-26794">
          <h2 data-id="element-26795">{t('legal.privacy.s1.title')}</h2>
          <p data-id="element-26796">{t('legal.privacy.s1.p1')}</p>

          <h2 data-id="element-26797">{t('legal.privacy.s2.title')}</h2>
          <p data-id="element-26798">{t('legal.privacy.s2.p1')}</p>
          <ul data-id="element-26799">
            <li data-id="element-26800">{t('legal.privacy.s2.l1')}</li>
            <li data-id="element-26801">{t('legal.privacy.s2.l2')}</li>
            <li data-id="element-26802">{t('legal.privacy.s2.l3')}</li>
          </ul>

          <h2 data-id="element-26803">{t('legal.privacy.s3.title')}</h2>
          <p data-id="element-26804">{t('legal.privacy.s3.p1')}</p>
          <ul data-id="element-26805">
            <li data-id="element-26806">{t('legal.privacy.s3.l1')}</li>
            <li data-id="element-26807">{t('legal.privacy.s3.l2')}</li>
            <li data-id="element-26808">{t('legal.privacy.s3.l3')}</li>
            <li data-id="element-26809">{t('legal.privacy.s3.l4')}</li>
          </ul>

          <h2 data-id="element-26810">{t('legal.privacy.s4.title')}</h2>
          <p data-id="element-26811">{t('legal.privacy.s4.p1')}</p>

          <h2 data-id="element-26812">{t('legal.privacy.s5.title')}</h2>
          <p data-id="element-26813">{t('legal.privacy.s5.p1')}</p>

          <h2 data-id="element-26814">{t('legal.privacy.s6.title')}</h2>
          <p data-id="element-26815">{t('legal.privacy.s6.p1')}</p>
          <ul data-id="element-26816">
            <li data-id="element-26817">{t('legal.privacy.s6.l1')}</li>
            <li data-id="element-26818">{t('legal.privacy.s6.l2')}</li>
            <li data-id="element-26819">{t('legal.privacy.s6.l3')}</li>
          </ul>

          <h2 data-id="element-26820">{t('legal.privacy.s7.title')}</h2>
          <p data-id="element-26821">{t('legal.privacy.s7.p1')}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-26822">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-26823">
            {t('legal.terms.title')} →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-26824">
            {t('legal.contactUs')}
          </button>
        </div>
      </div>
    </div>;
}